// extracted by mini-css-extract-plugin
module.exports = {"container":"BillerUploadSettings_container__2iBTL","divider":"BillerUploadSettings_divider__2dSBK"};